import { render } from "./ArticleIcons.vue?vue&type=template&id=54975c82&scoped=true"
import script from "./ArticleIcons.vue?vue&type=script&lang=js"
export * from "./ArticleIcons.vue?vue&type=script&lang=js"

import "./ArticleIcons.vue?vue&type=style&index=0&id=54975c82&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\User\\OneDrive - Universidad Nacional de Colombia\\Documentos\\Desarrollo\\Tempo\\Front\\Tempo-Front\\tempo-front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54975c82"]])

export default __exports__